import React from "react";
import { CustomImageNew } from "rylak-common/src/image/CustomImage.jsx";
import { getWmsIcon, getWmsIconHeight, getWmsIconWidth, getWmsName } from "~/cores/shipmentCore";
import { TurnrTooltip } from "rylak-common/src/components/TurnrTooltip/TurnrTooltip";

export default function WmsLogoIcon({ type, height, tooltip }) {
    const defaultWidth =
        getWmsIconWidth({
            type: type,
        }) || 100;

    const defaultHeight =
        getWmsIconHeight({
            type: type,
        }) || 15;

    const actualHeight = height || defaultHeight;

    const actualWidth = (actualHeight / defaultHeight) * defaultWidth;

    return (
        <TurnrTooltip content={tooltip}>
            <CustomImageNew
                fixedWidth={actualWidth}
                fixedHeight={actualHeight}
                src={getWmsIcon({
                    type: type,
                })}
                alt={getWmsName({
                    type: type,
                })}
                draggable={false}
            />
        </TurnrTooltip>
    );
}
